import React, { ReactNode } from 'react'
import classNames from 'classnames'
import Form from 'antd/lib/form'
import Upload from 'antd/lib/upload'
import { validateFile, imgExtensions, videoExtensions, documentExtensions, imageFileSize } from '@features/General'
import AccountBoxFillIcon from 'remixicon-react/AccountBoxFillIcon'
import styles from './index.scss'

interface IProps {
    shape?: 'circle' | 'rectangle'
    icon?: ReactNode
    preview?: boolean
    accept?: string
    name: string
    required?: boolean
    requiredMsg?: string
    rules?: any
    fileList: any
    setFileList: any
    multiple?: boolean
    customRequest?: any
    theme?: 'theme-1' | 'theme-2' | 'theme-3'
    itemRender?: any
    acceptedExtensions?: 'video' | 'image' | 'document' | ''
    fileSizeLimitation?: number
    disabled?: boolean
    size?: string | number
}
const UploadField = (props: IProps) => {
    const {
        shape = 'circle',
        icon = <AccountBoxFillIcon size={16} />,
        preview = true,
        accept = 'image/png, image/gif, image/jpeg, image/jpg, image/bmp',
        name,
        required = false,
        requiredMsg = '',
        rules = [],
        fileList,
        setFileList,
        multiple = false,
        theme = 'theme-1',
        itemRender,
        acceptedExtensions,
        fileSizeLimitation = 50,
        disabled = false,
        size = '',
        customRequest = ({ file, onSuccess }) => onSuccess('', file)
    } = props
    const handleChange = info => {
        if (!multiple) {
            if (info?.fileList?.length) {
                setFileList(info.fileList.filter(item => item.uid === info.file.uid))
            } else {
                setFileList([])
            }
        } else {
            const newFileList = [...fileList].filter(item => info.fileList.map(item => item.uid).includes(item.uid))
            info.fileList.forEach(item => {
                if (item.uid === info.file.uid && !newFileList.map(item => item.uid).includes(item.uid)) {
                    newFileList.push(item)
                }
            })
            setFileList(newFileList)
        }
    }
    return (
        <Form.Item
            name={name}
            rules={[
                {
                    required,
                    message: requiredMsg || `Please select ${name}`
                },
                () => ({
                    validator(_, value) {
                        if (!acceptedExtensions) {
                            return Promise.resolve()
                        }
                        const extensions =
                            acceptedExtensions === 'image'
                                ? imgExtensions
                                : acceptedExtensions === 'video'
                                ? videoExtensions
                                : documentExtensions
                        const validationResult = validateFile(
                            value?.file,
                            extensions,
                            acceptedExtensions === 'image' ? imageFileSize : fileSizeLimitation
                        )
                        if (!value) {
                            return Promise.resolve()
                        } else if (validationResult) {
                            return Promise.reject(validationResult)
                        } else {
                            return Promise.resolve()
                        }
                    }
                }),
                ...rules
            ]}
            hasFeedback
            className={classNames(styles['upload-box'], styles[theme], { ['has-file']: fileList?.length })}
        >
            <Upload
                accept={
                    acceptedExtensions === 'image'
                        ? 'image/png, image/gif, image/jpeg, image/jpg, image/bmp'
                        : acceptedExtensions === 'video'
                        ? 'video/*'
                        : acceptedExtensions === 'document'
                        ? 'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf'
                        : accept
                }
                disabled={disabled}
                style={{ width: size, height: size }}
                itemRender={itemRender}
                multiple={multiple}
                listType={preview ? 'picture' : 'text'}
                fileList={fileList}
                className={styles[`upload-${shape}`]}
                onChange={handleChange}
                customRequest={customRequest}
                showUploadList={{
                    showDownloadIcon: false,
                    previewIcon: file => {
                        return <></>
                    }
                }}
            >
                {icon}
            </Upload>
        </Form.Item>
    )
}

export default UploadField
